import { gql } from '@apollo/client'
import {
  BrandFeaturedOfferBlockFragment,
  BrandOfferCollectionBlockFragment,
  BrandOfferListBlockFragment
} from 'app/features/brands/blocks'
import { FeaturedOfferBlockFragment, OfferCollectionBlockFragment } from 'app/features/offer/blocks'
import {
  BaseBlock,
  ButtonBlockFragment,
  ColumnLayoutBlockFragment,
  FaqsBlockFragment,
  FeaturedContentCarouselBlockFragment,
  HeadingBlockFragment,
  HtmlBlockFragment,
  ImageBlockFragment,
  RichTextBlockFragment,
  ShareLinkBlockFragment,
  SpacerBlockFragment,
} from 'app/features/shared/blocks'
import { usePersistedCacheQuery } from 'app/hooks'

const query = gql`
  query fetchBrand($slug: String!, $draft: Boolean!) {
    Brands(where: { slug: { equals: $slug } }, draft: $draft) {
      docs {
        id
        name
        description
        longDescription
        logo {
          url
        }
        featuredImage {
          url
          alt
        }
        category {
          name
          slug
        }
        content {
          ${BrandFeaturedOfferBlockFragment.partialFragment}
          ${BrandOfferCollectionBlockFragment.partialFragment}
          ${BrandOfferListBlockFragment.partialFragment}
          ${ButtonBlockFragment.partialFragment}
          ${ColumnLayoutBlockFragment.partialFragment}
          ${FaqsBlockFragment.partialFragment}
          ${FeaturedContentCarouselBlockFragment.partialFragment}
          ${FeaturedOfferBlockFragment.partialFragment}
          ${HeadingBlockFragment.partialFragment}
          ${HtmlBlockFragment.partialFragment}
          ${ImageBlockFragment.partialFragment}
          ${OfferCollectionBlockFragment.partialFragment}
          ${RichTextBlockFragment.partialFragment}
          ${ShareLinkBlockFragment.partialFragment}
          ${SpacerBlockFragment.partialFragment}
        }
        slug
        meta {
          title
          description
        }
        isBookmarked
      }
    }
  }
`

export interface BrandQueryInput {
  slug: string
  draft: boolean
}

export interface BrandQueryOutput {
  Brands: {
    docs: {
      id: string
      name: string
      description?: string
      longDescription?: string
      logo: {
        url: string
      }
      featuredImage: {
        url: string
        alt: string
      }
      category: {
        name: string
        slug: string
      }
      content: BaseBlock[]
      slug: string
      meta: {
        title?: string
        description?: string
      }
      isBookmarked: boolean
    }[]
  }
}

export const useBrandQuery = (input: BrandQueryInput) =>
  usePersistedCacheQuery<BrandQueryOutput, BrandQueryInput>(query, { variables: input })

export const fetchBrandQuery = {
  query,
}
